let clib = {}

clib.imprecizeComparison = function (search_string, array) {
    let search_items = search_string.split(' ');
    let result_list = []

    for (let array_item in array) {
        let full_match_found = true;
        for (let item in search_items) {
        let found = false;

        for (let value in array[array_item]) {
            if (array[array_item][value] && array[array_item][value].toString().toLowerCase().indexOf(search_items[item].toLowerCase()) != -1)
            found = true;
        }

        if (!found)
            full_match_found = false;
        }

        if (full_match_found)
        result_list.push(array[array_item])
    }

    return result_list;
}

clib.clearQueryParams = function(currentData) {
    return {
        'env': currentData.env
    }
}

clib.gotoTop = function() {
    window.scrollTo(0, 0);
}


clib.dateFormatToUkrainian = function(val) {
    if (!val)
        return '-';

    let arr = val.split('-');
    let year = arr[0];
    let month = arr[1];

    switch (month) {
        case '01':
            month = 'січня';
            break;
        case '02':
            month = 'лютого';
            break;
        case '03':
            month = 'березня';
            break;
        case '04':
            month = 'квітня';
            break;
        case '05':
            month = 'травня';
            break;
        case '06':
            month = 'червня';
            break;
        case '07':
            month = 'липня';
            break;
        case '08':
            month = 'серпня';
            break;
        case '09':
            month = 'вересня';
            break;
        case '10':
            month = 'жовтня';
            break;
        case '11':
            month = 'листопада';
            break;
        case '12':
            month = 'грудня';
            break;
    }

    let day = parseInt(arr[2]).toString();

    return day + " " + month + " " + year + " року";
};

clib.isRestService = function(response_data) {
    if (!response_data) {
        return false;
    }
    const raw = (response_data.service_type || response_data.service_protocol || '').toString();
    const normalized = raw.trim().toUpperCase();
    return normalized.includes('REST') || normalized.includes('РЕСТ');
};

/* eslint-disable */
clib.transformDetailItem = function(item, response_data, settings, env, display_auth_loader=false) {
    let field = "";
    let route_id = "";
    let route_type = "";
    let final_value = response_data[item];

    for (let i in settings) {
        let setting = settings[i];
        if (item == setting.code) {
            if ((response_data[item] == "" || response_data[item] == null) && (typeof setting.display_empty === 'undefined' || (typeof setting.display_empty !== 'undefined' && !setting.display_empty))) {
                return false;
            }

            if (typeof setting.display !== 'undefined' && !setting.display) {
                return false;
            }

            if (typeof setting.display_prod !== 'undefined' && env == 'SEVDEIR' && !setting.display_prod) {
                return false;
            }

            if (typeof setting.display_test !== 'undefined' && env == 'SEVDEIR-TEST' && !setting.display_test) {
                return false;
            }

            if ((setting.code == 'current_wsdl_link' || setting.code == 'current_wsdl_updated_at') && clib.isRestService(response_data)) {
                return false;
            }

            // let result_object = 

            field = setting.verbose;
            let f_type = setting.type ? setting.type : "string";
            // console.log(f_type);

            if (setting.type == 'date') {
                final_value = clib.dateFormatToUkrainian(response_data[item]);
            }

            if (setting.type == 'timedelta') {
                final_value = clib.time_difference_ukrainian(response_data[item]);
            }

            if (setting.code == 'current_wsdl_link' && response_data.id) {
                final_value = `/api/v1/directory/service/${response_data.id}/wsdl_file/`;
            }

            if (setting.auth_required && display_auth_loader) {
                f_type = "loader";
            }

            // if (display_auth_required) {
            //     final_value = 'Необхідна авторизація'
            // }

            if (setting.type == 'routed') {
                route_id = response_data[setting.route_id_field];
                route_type = setting.route_type;
            }

            return {
                "type": f_type,
                "field": field,
                "value": final_value,
                "id": route_id,
                "route_type": route_type,
                "auth_required": setting.auth_required,
                "code": setting.code
            }
        }
    }

    return false;
}

clib.time_difference_ukrainian = function(targetTime) {
    if (!targetTime)
        return '';

    // Поточний час
    const now = new Date();
    // Цільовий час
    const target = new Date(targetTime);
    // Різниця в мілісекундах
    const delta = now - target;

    // Перетворення мілісекунд у дні, години, хвилини і секунди
    const days = Math.floor(delta / (1000 * 60 * 60 * 24));
    const hours = Math.floor((delta / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((delta / (1000 * 60)) % 60);
    const seconds = Math.floor((delta / 1000) % 60);

    // Об'єкт для зберігання значень і відповідних одиниць виміру
    const timeParts = {
        'д.': days,
        'год.': hours,
        'хв.': minutes,
        'сек.': seconds
    };

    // Формування результату, пропускаючи нульові значення
    const result = Object.entries(timeParts)
        .filter(([unit, value]) => value > 0)
        .map(([unit, value]) => `${value} ${unit}`)
        .join(', ');

    return result;
}

clib.time_difference_days = function(targetTime) {
    if (!targetTime)
        return '';

    // Поточний час
    const now = new Date();
    // Цільовий час
    const target = new Date(targetTime);
    // Різниця в мілісекундах
    const delta = now - target;

    // Перетворення мілісекунд у дні, години, хвилини і секунди
    const days = Math.floor(delta / (1000 * 60 * 60 * 24));

    // Функція для вибору правильного відмінка
    function getDaysDeclension(number) {
        const lastDigit = number % 10;
        const lastTwoDigits = number % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
            return 'днів';
        }

        if (lastDigit === 1) {
            return 'день';
        }

        if (lastDigit >= 2 && lastDigit <= 4) {
            return 'дні';
        }

        return 'днів';
    }

    // Формування результату
    const result = `${days} ${getDaysDeclension(days)}`;

    return result;
}

clib.isLessThan30DaysLeft = function(not_after) {
    // Parse the expiration date
    const expirationDate = new Date(not_after);
  
    // Get the current date
    const currentDate = new Date();
  
    // Calculate the difference in time
    const timeDifference = expirationDate - currentDate;
  
    // Convert time difference from milliseconds to days
    const daysLeft = timeDifference / (1000 * 60 * 60 * 24);
  
    // Check if less than 30 days are left
    return daysLeft < 30 && daysLeft > 0;
}

clib.isExpirationDateValid = function(not_after) {
    const expirationDate = new Date(not_after);
    const currentDate = new Date();
    return expirationDate > currentDate;
}

clib.transformListItem = function(item, response_data, settings, env) {
    let field = "";
    let route_id = "";
    let route_type = "";
    let final_value = response_data[item];

    for (let i in settings) {
        let setting = settings[i];
        if (item == setting.code) {
            if (typeof setting.display !== 'undefined' && !setting.display) {
                return false;
            }

            if (typeof setting.display_prod !== 'undefined' && env == 'SEVDEIR' && !setting.display_prod) {
                return false;
            }

            if (typeof setting.display_test !== 'undefined' && env == 'SEVDEIR-TEST' && !setting.display_test) {
                return false;
            }

            // let result_object = 

            field = setting.verbose;

            if (setting.type == 'date') {
                final_value = clib.dateFormatToUkrainian(response_data[item]);
            }

            if (setting.type == 'routed') {
                route_id = response_data[setting.route_id_field];
                route_type = setting.route_type;
            }

            return {
                "type": setting.type,
                "field": field,
                "value": final_value,
                "id": route_id,
                "route_type": route_type
            }
        }
    }

    return false;
}

clib.uuidv4 = function() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}  

clib.getFiltersQuery = function(config, object_type) {
    return {...config.query_params, ...config.filter_params[object_type]};
    // if (object_type == 'organization')
    //     return {...config.query_params, ...config.filter_params['organization']};
    // else if (object_type == 'information_resource')
    //     return {...config.query_params, ...config.filter_params['information_resource']};
    // else if (object_type == 'subsystem')
    //     return {...config.query_params, ...config.filter_params['subsystem']};
    // else if (object_type == 'interface')
    //     return {...config.query_params, ...config.filter_params['interface']};
}

export default clib;